export const ALGOLIA_INDEX_NAME = process.env.VUE_APP_ALGOLIA_INDEX_NAME || 'dev_SUPPLIERS';
export const ALGOLIA_SEARCH_API_KEY = process.env.VUE_APP_ALGOLIA_SEARCH_API_KEY || '85c6d2e45c47e5d160d3513551a3550b';
export const GOOGLE_MAPS_API_KEY = process.env.VUE_APP_GOOGLE_MAPS_API_KEY || 'AIzaSyAu7FPPJmcv4ILa4wYw6lktcRxDoJg57X0';
